import { useMemo } from 'react';

import { useDriverShell } from '../../scenes/driver/DriverDayProvider';
import { APP_TAB, TAB_BAR_TABS } from '../../scenes/driver/driverRoutes';

/** The bottom bar tabs for this user's role (empty outside the main app shell). */
const useVisibleTabs = () => {
	const { tabBarVariant, canViewServiceRuns } = useDriverShell() || {};

	return useMemo(() => (
		(TAB_BAR_TABS[tabBarVariant] || []).filter(tab => tab !== APP_TAB.ALL_RUNS || canViewServiceRuns)
	), [canViewServiceRuns, tabBarVariant]);
};

export default useVisibleTabs;
